var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConsultRoom = function SvgConsultRoom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07.-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Menu",
    transform: "translate(-250.000000, -238.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Navigation-Bar-/-Teleconsult",
    transform: "translate(230.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teleconsult-List",
    transform: "translate(0.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,15.4375 C16.9462358,15.4375 21.7741574,16.6372966 21.9923448,19.0193894 L22,19.1875 L22,22 L7,22 L7,19.1875 C7,16.69375 11.996875,15.4375 14.5,15.4375 Z M14.5,7 C16.5710678,7 18.25,8.67893219 18.25,10.75 C18.25,12.8210678 16.5710678,14.5 14.5,14.5 C12.4289322,14.5 10.75,12.8210678 10.75,10.75 C10.75,8.67893219 12.4289322,7 14.5,7 Z M10.5,2 C10.7761424,2 11,2.22385763 11,2.5 L10.9999485,6.75641618 C9.89868752,7.66561995 9.1576912,8.99544212 9.02235117,10.500491 L5,10.5 L5,14.5 L2.4,11.0333333 C2.14035574,10.687141 2,10.2660738 2,9.83333333 L2,2.5 C2,2.22385763 2.22385763,2 2.5,2 L10.5,2 Z M7.5,7.75 L5.5,7.75 L5.5,9.25 L7.5,9.25 L7.5,7.75 Z M7.5,3.5 L5.5,3.5 L5.5,7 L7.5,7 L7.5,3.5 Z",
    id: "Combined-Shape",
    fill: "#F6F7FA"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConsultRoom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/consult-room.0b3b2238.svg";
export { ForwardRef as ReactComponent };